import { useEffect, useState } from 'react';
import FaqSection from 'src/components/demo-day/faqsection/FaqSection';
import Header from 'src/components/demo-day/header/Header';
import DemoDayHeroSection from 'src/components/demo-day/hero-section/HeroSection';
import Instruction from 'src/components/demo-day/instruction/Instruction';
import Judges from 'src/components/demo-day/judges/Judges';
import cx from './index.module.scss';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { clearMyVenture, getDemoDay, getVentureCounters, clearDemoDay, getVentureList, clearVentureList, getGlobalOngoingDemoDay } from 'src/store/venture/venture.slice';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import FullPageLoader from 'src/components/common/full-page-skeleton-loading/FullPageSkeletonLoading';
import ExclusiveWebinar from 'src/components/demo-day/exclusive-webinar/ExclusiveWebinal';
import { TSingleVentureRequest, TVentureRequest } from 'src/services/apiEndpoint.types.ts/ventures/ventures.types';
import TopperSection from 'src/components/demo-day/topper-section/TopperSection';
const DemoDay = () => {
  const dispatch = useAppDispatch();
  const { getIdentities } = useGetIdentity();
  const { myVenture, loading, ventureLoading, ventures } = useAppSelector(
    (store) => store.venture
  );
  const { authenticatedId, loggedInUserType } = getIdentities();
  function getTopVentures() {
    const payload: TVentureRequest = {
      isSelected: true
    }
    dispatch(getVentureList(payload))
  }
  useEffect(() => {
    const payload: TSingleVentureRequest = {
      ...(!authenticatedId ? {} : loggedInUserType === 'User' ? { userId: authenticatedId } : { companyId: authenticatedId })
    }
    dispatch(getVentureCounters(payload))

    return () => {
      dispatch(clearMyVenture())
    }
  }, [dispatch, loggedInUserType, authenticatedId]);

  useEffect(() => {
    if (myVenture?.id) {
      dispatch(getDemoDay({ ventureVerseId: myVenture?.id }))
    }
    return () => {
      dispatch(clearDemoDay())
    }
  }, [myVenture?.id]);
  useEffect(() => {
    window.scrollTo(0, 0);
    getTopVentures();
    dispatch(getGlobalOngoingDemoDay())
    return () => {
      dispatch(clearVentureList())
    }
  }, []);

  return (
    <div className={cx.demoDay}>
      <Header />
      {!loading && !ventureLoading && <div className={cx.demoDayContent}>
        <DemoDayHeroSection />
        {ventures?.length > 0 && <TopperSection ventures={ventures} />}
        <Instruction />
        <Judges />
        <ExclusiveWebinar />
        <FaqSection />
      </div>}
      {(loading || ventureLoading) && <FullPageLoader />}

    </div>
  );
};

export default DemoDay;
